"use client"

import DashboardLayout from "@/views/dashboard/DashboardLayout"
import ProposedProfessions from "./ProposedProfessions"


export default function ProposedProfessionsPage() {
  return (
    <DashboardLayout>
      <ProposedProfessions />
    </DashboardLayout>
  )
}
